module.exports = __webpack_public_path__ + "src/assets/img/checkLarge.c30afe6f8f20a1e29541523608339e04.svg";